import { createVNode as o, mergeProps as a } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/OneToOneOutlinedStandard.js";
import i from "../components/PfIcon.js";
const e = (t, n) => {
  const r = {
    ...t,
    ...n.attrs
  };
  return o(i, a(r, {
    icon: d
  }), null);
};
e.displayName = "OneToOneOutlinedStandard";
e.inheritAttrs = !1;
export {
  e as default
};
